<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
			<!-- * 内页banner * -->
			<div class="page-banner">
				<img :src="title=='党建引领'?require('@/assets/images/banner08.png'):require('@/assets/images/banner07.png')" alt="内页banner">
				<div class="nybt">
					<h3>内页banner</h3>
				</div>
			</div>
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					{{title}}
				</div>
			</div>

			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">


					<!-- * 右侧 * -->
					<div class="page-wrap-right">

						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
								<ul class="xypg-left-nav">
									<li :class="item.categoryCode==type?'clicked':''" v-for="item in actList">
										<a href="javascript:void(0)"
											@click="changeData(item.categoryCode,item.categoryName)">
											{{item.categoryName}}</a>
										<div class="first-nav-btn"></div>
									</li>
								</ul>
							</div>
						</div>
						<div class="xypg-right-content">
							<div>
								<img :src="detail.image" v-if="detail.image">
								<div v-html="detail.cmsArticleData?detail.cmsArticleData.content:''"></div>
							</div>
						</div>
					</div>


				</div>
			</div>

			<Footer />



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';

	import {
		articleDetail,
		categorysortPage,
		articleList
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pageNum: 1,
				pageCount: 0,
				actList: [],
				type: '',
				title: '',
				total: 0,
				list: [],
				pageNum: 1,
				totalPage: 0,
				pageSize:10
			}
		},

		mounted() {
			
			this.type = this.$route.query.type
			this.title=this.$route.query.title
			this.getCategorysortPage()
			this.getCaseList()
			

		},

		methods: {
			goDetail(id,name) {
				const route = this.$router.resolve({
					path: '/context',
					query: {
						id: id,
						name:name
					}
				});
				window.open(route.href, '_blank');
			},
			
			
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						if (item.categoryName == '社会责任') {
							this.actList = item.children
							this.actList.sort((a, b) => a.orderNum - b.orderNum);
							
						}
					})

				});
			},
			changeData(id, title) {
				this.type = id
				this.title = title
				this.getCaseList()
				
			},
			getCaseList() {
				articleList({
					pageNum: 1,
					pageSize: 1,
					status: 1,
					categoryCode: this.type,
				}).then(res => {
					if (res.rows.length>0) {
						this.id = res.rows[0].id
						this.getNewDetail()
					}
				});
			},

			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
						let cmsArticleData = this.detail.cmsArticleData
						if (cmsArticleData && cmsArticleData.content) {
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g,
								'<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}


				});
			},



		}
	}
</script>

<style scoped>
	

	
</style>